const storage = localStorage;

function saveCommonInput(input) {
    return {
        name: input.name,
        value: input.value
    };
}

function saveCheckboxInput(input) {
    return {
        type: "checkbox",
        name: input.name,
        value: input.getAttribute("value")
    };
}

function saveSelect(select) {
    return {
        type: "select",
        name: select.name,
        value: select.value
    };
}

function saveEditor(element) {
    return {
        type: "editor",
        name: element.dataset.storeEditor,
        value: element.querySelector("[contenteditable]").innerHTML
    };
}

function saveForm(form) {
    const name = form.dataset.storeForm;
    const data = [];

    form.querySelectorAll("input[type=text][name], input[type=number][name]")
        .forEach(input => data.push(saveCommonInput(input)));
    
    form.querySelectorAll("input[type=checkbox][name]:checked")
        .forEach(input => data.push(saveCheckboxInput(input)));

    form.querySelectorAll("select[name]")
        .forEach(select => data.push(saveSelect(select)));

    form.querySelectorAll("[data-store-editor]")
        .forEach(element => data.push(saveEditor(element)));

    storage.setItem(name, JSON.stringify(data));
}

function save() {
    document.querySelectorAll("[data-store-form]")
        .forEach(saveForm);
}

function restoreCommonInput(form, item) {
    const element = form.querySelector(`[name=${ item.name }]`);

    if (element) {
        element.value = item.value;
        element.dispatchEvent(new Event("input"));
    }
}

function restoreCheckboxInput(form, item) {
    let element = null;

    if (item.value) {
        element = form.querySelector(`[name="${ item.name }"][value="${ item.value }"]`);
    }
    else {
        element = form.querySelector(`[name="${ item.name }"]`);
    }

    if (element) {
        element.checked = true;
        element.dispatchEvent(new Event("change"));
    }
}

function restoreSelect(form, item) {
    const select = form.querySelector(`[name="${ item.name }"]`);

    if (select) {
        select.value = item.value;
        select.dispatchEvent(new CustomEvent("select.change"));
    }
}

function restoreEditor(form, item) {
    if ("qeditor" in window) {
        qeditor.clipboard.dangerouslyPasteHTML(item.value);
    }
}

function restoreItem(form, item) {
    switch (item.type) {
        case "checkbox":
            restoreCheckboxInput(form, item);
            break;
        case "select":
            restoreSelect(form, item);
            break;
        case "editor":
            restoreEditor(form, item);
            break;
        default:
            restoreCommonInput(form, item);
    }
}

function restoreForm(form) {
    const name = form.dataset.storeForm;

    try {
        let data = JSON.parse(storage.getItem(name));

        if (!Array.isArray(data)) {
            data = [];
        }

        for (const item of data) {
            restoreItem(form, item);
        }
    }
    finally {
        storage.removeItem(name);
    }
}

function restore() {
    document.querySelectorAll("[data-store-form]")
        .forEach(restoreForm);
}

function init(list) {
    list.addEventListener("click", (event) => {
        const btn = event.target.closest("[data-url]");

        if (!btn) {
            return;
        }

        save();
        window.location.href = btn.dataset.url;
    });
}

function initAll() {
    document.querySelectorAll(".auth-list")
        .forEach(init);
}

export {
    initAll as initAuthBlocks,
    restore
}
